import { Validators } from "@angular/forms";

const EMAIL_MAX_CHARACTERS = 50;

const EMAIL_VALIDATOR_REGEX = /.+@.+\..*[^.]$/;
const EMAIL_VALIDATOR = [
  Validators.required,
  Validators.maxLength(EMAIL_MAX_CHARACTERS),
  Validators.pattern(EMAIL_VALIDATOR_REGEX), // (at least one character)@(1+ character).(0+ character)(not period)
];

export { EMAIL_VALIDATOR, EMAIL_VALIDATOR_REGEX };
